export default __webpack_public_path__ + "static/media/familySA.7f5d6dc5.svg";